// extracted by mini-css-extract-plugin
module.exports = {"qualification_wrapper":"qualityCheck_qualification_wrapper__3_10k","input_wrapper":"qualityCheck_input_wrapper__1w6y6"};